import { Outlet, createFileRoute } from '@tanstack/react-router'

import { Shell } from '@/components/layout/shell'
import { requireAuth } from '@/features/auth/guards/require-auth'

// Single shared layout for all global (non-project) authenticated routes.
// The <Shell> (Sidebar + Topbar) is rendered ONCE here and persists across
// every navigation between these routes — only the <Outlet/> content swaps.
//
// Previously every route/page rendered its own <Shell>, so navigating between
// any two top-level destinations fully remounted the sidebar. That was
// invisible for `defaultOpen:true` folders but flickered on the
// `defaultOpen:false` groups («Звіти», «Довідники»), whose NavFolder reset to
// collapsed and replayed its open animation on every click. With the Shell
// hoisted here the sidebar never unmounts, and the site-wide
// `defaultViewTransition` cross-fade scopes to the content region.
//
// `requireAuth` runs here as the section's auth boundary; child routes keep
// their own beforeLoad (e.g. the is_staff gates on /material-issues,
// /transfers) which run after this one. The project-scoped subtree
// (`projects/$projectId/_layout`) keeps its own <Shell activeProjectId> and is
// intentionally NOT nested under this layout.
export const Route = createFileRoute('/_app')({
  beforeLoad: requireAuth,
  component: AppLayout,
})

function AppLayout() {
  return (
    <Shell>
      <Outlet />
    </Shell>
  )
}
